import * as React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import TicketBreakdown from '../TicketBreakdown'
import cls from './HostPortalStatCard.module.scss'

const HostPortalGenderRatio = ({ tickets }) => (
  <div className={classnames(cls.statContainer, 'p-4 justify-center')}>
    <div className="border border-black border-solid border-opacity-20">
      <TicketBreakdown tickets={tickets} />
    </div>
  </div>
)

HostPortalGenderRatio.defaultProps = {
  tickets: [],
}

HostPortalGenderRatio.propTypes = {
  tickets: PropTypes.arrayOf(
    PropTypes.shape({
      gender: PropTypes.string,
      genderPreference: PropTypes.string,
      sold: PropTypes.number,
      available: PropTypes.number,
    })
  ),
}

export default HostPortalGenderRatio
